import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import App from './components/app/App';
import ContactUs from './components/contactUs/ContactUs';
import Bulletin from './components/bulletin/Bulletin';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Topbar from './components/topbar/Topbar';
import Watching from './components/watching/Watching';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <Topbar />
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/home" element={<App />} />
      <Route path="/watching" element={<Watching />} />
      <Route path="/contact_us" element={<ContactUs />} />
      <Route path="/bulletin" element={<Bulletin />} />
    </Routes>
  </BrowserRouter>
);